import React, { Component } from 'react'
import PlayIcon from '../icon/PlayIcon'
// import MovieImg from '../movie/MovieImg'
// import Link from 'next/link'
// import Router from 'next/router'
import * as ls from '../../lib/localStorage'
// import { logEvent } from '../../utils/analytics'
import styles from './styles/SeriesPlay.less'

function _gaEvent(action, label, link) {
	// logEvent('影音详情页', action, label);

	window.location.href = link;
}


class SeriesPlay extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			next_data: ''
		},
			this.next_auto_play;

	}
	componentDidMount() {
		this.filtrateData();

	}
	componentWillUnmount() {
		clearTimeout(this.next_auto_play);
	}
	filtrateData() {
		const { data } = this.props

		let movieData = ls.all('read', 'movieData', 'json'),
			ratioData = this.filtrateRatio(movieData),
			nextData = this.filtrateNextData(data.data, ratioData);

	}
	filtrateNextData(data, ratioData) {
		let nextData = '';


		for (var i = 0; data.length > i; i++) {
			let exist = ratioData.indexOf(data[i].id);
			if (exist == -1) {
				nextData = data[i];
				break;
			}
		}
		this.setState({
			next_data: nextData
		})
		if (nextData != '') {
			this.nextAutoPlay();
		}
	}
	// 筛选出>90的
	filtrateRatio(data) {
		let array = [];

		if (data == null) {
			return array
		}
		data.map((value, index) => {
			if (value.ratio >= 90) {
				array.push(value.id)
			}
		})
		return array
	}
	nextAutoPlay() {
		this.next_auto_play = setTimeout(() => {
			this.nextMovie()
		}, 5000)

	}
	nextMovie() {
		const { next_data } = this.state

		_gaEvent('繼續播放', next_data.title, next_data.link);


	}
	render() {
		const { next_data } = this.state;
		const { img_url } = this.props;

		return (
			<section>
				{ next_data != '' ?
					<div className={ styles["next-player"] }>
						<div className={ styles["bg-cover-img"] }>
							<img src={ img_url } />
						</div>
						<section className={ styles["shade-bg"] }>
							<div className={ styles["fenestella"] }>
								<a onClick={ () => this.nextMovie() } >
									<div className={ styles["next-img"] } >
										<img src={ next_data.thumb } />
										<div className={ styles["movie-time"] }>{ next_data.play_time }</div>
									</div>
								</a>
								<div className={ styles["movie-message"] }>
									<div className={ styles["desc"] } >{ next_data.title }</div>
									<div className={ styles["movie-btn"] }>
										<a onClick={ () => this.nextMovie() }>
											<PlayIcon />
										</a>
					           5秒後自動播放
					        </div>
								</div>
								<div className={ styles["reset-play-btn"] } onClick={ this.props.refresh } ></div>
							</div>
						</section>
					</div>
					: null }
			</section>
		)
	}

}

export default SeriesPlay

